angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "TIMEAGO": {
    "MOMENT": "a moment ago",
    "MINUTE": "a minute ago",
    "MINUTES": "%d minutes ago",
    "HOUR": "an hour ago",
    "HOURS": "%d hours ago",
    "YESTERDAY": "yesterday",
    "DAYS": "%d days ago",
    "WEEK": "a week ago",
    "WEEKS": "%d weeks ago",
    "MONTH": "a month ago",
    "MONTHS": "%d months ago",
    "YEAR": "a year ago",
    "YEARS": "%d years ago"
  },
  "MORE_THAN": "more than"
}
);  }]);


//////////////////
// WEBPACK FOOTER
// ./webpack_loaders/nls.js!./app/src/directives/time_ago.json
// module id = 503
// module chunks = 24